import script from "./appcharts.vue?vue&type=script&setup=true&lang=ts"
export * from "./appcharts.vue?vue&type=script&setup=true&lang=ts"

import "./appcharts.vue?vue&type=style&index=0&id=4a4633dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4633dd"]])

export default __exports__